<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="stakeholderQuestionnaireModal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="ModalLabel">利害關係人意見回饋</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form id="fm_question" action="">
              <p>1. 請問您的身份 / 與裕融的關係(可複選)</p>
              <div v-for="(item, index) in identity" :key="index" style="display:inline;">
                <input type="checkbox" class="inp-cbx" :id="'identity' + index " :name="item.name">
                <label class="cbx" :for="'identity' + index ">
                    <span><svg viewbox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg></span>
                    {{ item.identity }}
                </label>
              </div>
              <p class="my-3">2. 請您針對下列各項議題，勾選您關心的程度</p>
              <table class="table table-striped questionnaire-table">
                <thead>
                  <tr>
                    <th scope="col" width="25%">關注議題</th>
                    <th scope="col" width="15%">非常關注</th>
                    <th scope="col" width="15%">很關注</th>
                    <th scope="col" width="15%">普通</th>
                    <th scope="col" width="15%">僅稍微關注</th>
                    <th scope="col" width="15%">不關注</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in issue" :key="index">
                    <td scope="row">{{ item.issue }}</td>
                    <td v-for="(n, i) in 5" :key="i">
                      <label :for="'issue' + index + '_' + i" class="radio">
                        <input type="radio" :name="item.name" :id="'issue' + index + '_' + i" :value="5 - i" style="display:none;" required>
                        <span class="label"></span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="my-3">3. 其他建議裕融新增的議題或意見</p>
              <textarea id="other_suggestion" name="other_suggestion" rows="4" cols="50"></textarea>
              <div class="text-right my-3">
                <button class="btn questionnaire-btn" @click="recevie">提交</button>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#other_suggestion {
  resize: none;
  border-radius: 5px;
  border: 1px solid #c8ccd4;
  width: 100%;
}
</style>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      identity: [
        { name: 'customer' ,identity: '顧客' },
        { name: 'employee' ,identity: '員工' },
        { name: 'investor_shareholder' ,identity: '投資人/股東' },
        { name: 'neighborhood' ,identity: '社區鄰里' },
        { name: 'organization_ngo' ,identity: '公益團體/NGO' },
        { name: 'supplier_partner' ,identity: '供應商/合作夥伴' },
        { name: 'institutions_academic' ,identity: '研究機構/學界' },
        { name: 'government' ,identity: '政府部門' },
        { name: 'media' ,identity: '媒體' },
        { name: 'peers' ,identity: '同業' },
        { name: 'creditor' ,identity: '債權人(銀行機構)' },
        { name: 'other_relationship' ,identity: '其他' },
      ],
      issue: [
        { name:'operational_performance' , issue: '營運績效' },
        { name:'integrity_management' , issue: '誠信經營' },
        { name:'corporate_governance' , issue: '公司治理' },
        { name:'risk_management' , issue: '風險管理' },
        { name:'sustainable_business' , issue: '營運持續與緊急應變計畫' },
        { name:'compliance' , issue: '法令遵循' },
        { name:'information_disclosure' , issue: '資訊透明揭露' },    // 新增20240920
        { name:'personal_info_protection' , issue: '資安治理與個資保護' },      // 改名20240920
        { name:'inclusive_financing' , issue: '普惠金融' },           // 新增
        { name:'sustainable_financing' , issue: '永續金融' },         // 新增20240920
        { name:'product_service' , issue: '創新產品與服務' },
        { name:'customer_handling' , issue: '顧客關係管理' },
        { name:'sustainable_supplier' , issue: '永續供應商管理' },   // 新增
        { name:'salary_system' , issue: '員工薪獎福利與人才升遷制度' },
        { name:'talent_education' , issue: '人才發展與培育' },
        { name:'working_environment' , issue: '人權保障與友善工作環境' },
        { name:'social_participation' , issue: '社會參與' },  // 新增
        { name:'greenhousegas_reduction' , issue: '永續營運環境管理' },
        { name:'climate_change' , issue: '氣候變遷策略' },   // 新增  
        { name:'biodiversity' , issue: '生物多樣性' }   // 20260331   新增  
      ]
    }
  },
  methods:{
    recevie(){      
      var jsonStr = {};
      for (var i = 0; i < document.forms['fm_question'].elements.length; i++) {        
        let item = document.forms['fm_question'].elements[i];        
        if(item.type === 'checkbox'){
          jsonStr[item.name] = item.checked ? 1 : 0;
        }
        else if(item.type === 'textarea'){
          jsonStr[item.name] = item.value
        }
        else if(item.type === 'radio'){
          if(item.checked)
            jsonStr[item.name] = item.value;
        }        
      }
      this.common.postApi(this.apiUrl + "api/tac/stakeholder", JSON.stringify(jsonStr)).then(o=> { debugger; document.getElementsByClassName('close')[0].click(); })            
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Questionnaire.vue